import { Icon, useStyleConfig } from '@chakra-ui/react';
import React from 'react';

import { WLIconProps } from '../icon.props.interface';

const InformationTechnologyIcon: React.FC<WLIconProps> = ({
  variant,
  ...rest
}) => {
  const styles = useStyleConfig('Icon', { variant });

  return (
    <Icon viewBox="0 0 255 255" {...rest} __css={styles}>
      <desc id="svgdescTechnology">computer with code</desc>
      <path
        className="background"
        d="M127.5 0C57.2 0 0 57.2 0 127.5S57.2 255 127.5 255 255 197.8 255 127.5 197.8 0 127.5 0z"
      />
      <path
        className="accent"
        d="M158.7 204.9c-12.7-.4-13.6-18.2-13.6-18.2h-32.8s-1 17.8-13.7 18.2c-5.8.8-5.3 6.8 0 6.8l30.1.1 30.1.1c5.2-.2 5.7-6.2-.1-7zM197.2 65H60.1c-8.7 0-15.9 7.1-15.9 15.9v83.8c0 8.7 7.1 15.9 15.9 15.9h137.1c8.7 0 15.9-7.1 15.9-15.9V80.9c0-8.7-7.2-15.9-15.9-15.9zm-68.5 110.5c-2 0-3.6-1.6-3.6-3.6s1.6-3.6 3.6-3.6 3.6 1.6 3.6 3.6-1.7 3.6-3.6 3.6zm67.8-18.7c0 4-3.3 7.4-7.4 7.4H68.2c-4.1 0-7.4-3.3-7.4-7.4v-68c0-4.1 3.3-7.4 7.4-7.4h120.9c4.1 0 7.4 3.3 7.4 7.4v68z"
      />
      <path
        className="accent"
        d="M90.6 120.9c5.6-6.6 11.9-12.4 18.1-18.4 2.1-2.1 5-1.8 6.9.1 1.9 2 2.1 4.7 0 7-3.4 3.7-7 7.3-10.7 10.7-1.9 1.8-2 3.1 0 5 3.5 3.2 6.8 6.6 10.1 10 2.6 2.7 2.8 5.6.7 7.7-2.3 2.3-5.1 2.2-7.9-.6-5.8-5.6-11.5-11.3-17.2-17v-4.5zM166.7 124.7c-5.6 6.5-11.9 12.3-18.1 18.3-2.1 2-5 1.8-6.9-.2-1.9-2-2.1-4.7 0-6.9 3.1-3.3 6.3-6.4 9.5-9.6 3.5-3.5 3.5-3.5.1-6.9-3-3-6-5.9-8.9-8.9-2.7-2.8-3-5.6-.7-7.9 2.3-2.3 5-2.1 7.8.8 5.7 5.8 11.8 11.2 17.1 17.5.1 1.3.1 2.6.1 3.8zM120.8 138.3c1.3-7.4 2.7-15.2 4.1-23.1.5-3.1 1-6.1 1.7-9.2.7-3.3 3.1-5.1 5.9-4.6 2.8.5 4.6 3 4 6.3-1.8 10.7-3.7 21.4-5.7 32-.5 2.9-3 4.7-5.5 4.3-2.7-.2-4.6-2.5-4.5-5.7zM158.7 204.9c-12.7-.4-13.6-18.2-13.6-18.2h-32.8s-1 17.8-13.7 18.2c-5.8.8-5.3 6.8 0 6.8l30.1.1 30.1.1c5.2-.2 5.7-6.2-.1-7z"
      />
      <path
        className="accent"
        d="M197.2 65H60.1c-8.7 0-15.9 7.1-15.9 15.9v83.8c0 8.7 7.1 15.9 15.9 15.9h137.1c8.7 0 15.9-7.1 15.9-15.9V80.9c0-8.7-7.2-15.9-15.9-15.9zm-68.5 110.5c-2 0-3.6-1.6-3.6-3.6s1.6-3.6 3.6-3.6 3.6 1.6 3.6 3.6-1.7 3.6-3.6 3.6zm67.8-18.7c0 4-3.3 7.4-7.4 7.4H68.2c-4.1 0-7.4-3.3-7.4-7.4v-68c0-4.1 3.3-7.4 7.4-7.4h120.9c4.1 0 7.4 3.3 7.4 7.4v68z"
      />
      <path
        className="accent"
        d="M90.6 120.9c5.6-6.6 11.9-12.4 18.1-18.4 2.1-2.1 5-1.8 6.9.1 1.9 2 2.1 4.7 0 7-3.4 3.7-7 7.3-10.7 10.7-1.9 1.8-2 3.1 0 5 3.5 3.2 6.8 6.6 10.1 10 2.6 2.7 2.8 5.6.7 7.7-2.3 2.3-5.1 2.2-7.9-.6-5.8-5.6-11.5-11.3-17.2-17v-4.5zM166.7 124.7c-5.6 6.5-11.9 12.3-18.1 18.3-2.1 2-5 1.8-6.9-.2-1.9-2-2.1-4.7 0-6.9 3.1-3.3 6.3-6.4 9.5-9.6 3.5-3.5 3.5-3.5.1-6.9-3-3-6-5.9-8.9-8.9-2.7-2.8-3-5.6-.7-7.9 2.3-2.3 5-2.1 7.8.8 5.7 5.8 11.8 11.2 17.1 17.5.1 1.3.1 2.6.1 3.8zM120.8 138.3c1.3-7.4 2.7-15.2 4.1-23.1.5-3.1 1-6.1 1.7-9.2.7-3.3 3.1-5.1 5.9-4.6 2.8.5 4.6 3 4 6.3-1.8 10.7-3.7 21.4-5.7 32-.5 2.9-3 4.7-5.5 4.3-2.7-.2-4.6-2.5-4.5-5.7z"
      />
    </Icon>
  );
};

export default InformationTechnologyIcon;
